import React from 'react';

import {
  SkillContainer,
  SkillHeader,
  Container,
  ChallengeSticker,
  ExerciseStickerContent,
  ExercisesContainer,
  ExerciseLanguageContent,
  ChallengeName,
  ChallengeEmptyText,
  LevelsHeader,
  ExerciseLink,
} from './styles';

export default function ExerciseTab({ profile }) {
  const { exercises } = profile;

  const renderExercise = (exercise, index) => {
    return (
      <ExerciseLink to={`/exercises/${exercise._id}`} key={index}>
        <ChallengeSticker key={exercise.name} image={exercise.contestBackground}>
          <LevelsHeader>
            {exercise.completedLevels}/{exercise.totalLevels} Levels Completed
          </LevelsHeader>
          <ExerciseStickerContent>
            <ChallengeName>{exercise.name}</ChallengeName>
            {exercise.completedLanguages.concat(exercise.languagesUsed).length ? (
              <ExerciseLanguageContent>
                Languages Used:&nbsp;
                {exercise.completedLanguages.concat(exercise.languagesUsed).map((language, index) => (
                  <span>{(index ? ', ' : '') + language}</span>
                ))}
              </ExerciseLanguageContent>
            ) : null}
            {exercise.completedLanguages.length ? (
              <ExerciseLanguageContent>
                Languages Completed:&nbsp;
                {exercise.completedLanguages.map((language, index) => (
                  <span>{(index ? ', ' : '') + language}</span>
                ))}
              </ExerciseLanguageContent>
            ) : null}
          </ExerciseStickerContent>
        </ChallengeSticker>
      </ExerciseLink>
    );
  };

  return (
    <Container>
      <SkillContainer height={'auto'} style={{ marginRight: 0 }}>
        <SkillHeader>Latest exercises</SkillHeader>
        <ExercisesContainer>
          {exercises && exercises.length > 0 ? (
            exercises.map(renderExercise)
          ) : (
            <ChallengeEmptyText>You have not participated in any exercises yet...</ChallengeEmptyText>
          )}
        </ExercisesContainer>
      </SkillContainer>
    </Container>
  );
}
